//意大利语
export default{
    今日涨跌:"Variazione di oggi",
    商品:"Merce",
    交割:"Consegna",
  关于我们:"chi siamo",
  账变记录:"Record di modifica dell'account",
  股票:"azione",
  加密货币:"criptovaluta",
  加载中:"caricamento...",
  已经全部加载完毕:"Sono stati tutti caricati",
  暂无记录:"Nessuna registrazione",
  高级认证:"Certificazione avanzata",
  姓名:"Nome",
  请输入姓名:"Per favore digita il tuo nome",
  护照编号:"Numero di passaporto",
  请输入护照编号:"Inserisci il numero del passaporto",
  护照照片:"foto del passaporto",
  申请认证:"Richiedi la certificazione",
  提示:"suggerimento",
  确定:"Sicuro",
    全球领先的期货和数字资产平台: "Piattaforma leader globale per futures e asset digitali",
  提交失败:"Invio non riuscito",
  上传失败:"caricamento fallito",
  身份认证:"Autenticazione",
  身份证号:"Numero di identificazione",
  请输入身份证号:"Inserisci il numero di identificazione",
  身份证照片:"Foto d'identità",
  申请认证:"Richiedi la certificazione",
  修改资金密码:"Modifica la password del fondo",
  旧密码:"vecchia password",
  请输入旧密码:"Inserisci la vecchia password",
  新密码:"nuova password",
  请输入6位数字:"Inserisci 6 cifre",
  确认新密码:"Conferma la nuova password",
  请再次输入新密码:"Inserisci nuovamente la nuova password",
  提交:"invia",
  请输入新密码:"Inserisci una nuova password",
  请输入6位数新密码:"Inserisci una nuova password di 6 cifre",
  请确认两次密码输入一致:"Conferma che le due password inserite coincidono",
  修改登录密码:"Cambia password di accesso",
  密码长度:"Password (6-12 caratteri)",
  密码长度提示:"Inserisci da 6 a 12 caratteri, inclusi numeri o lettere",
  客服:"assistenza clienti",
  永续:"Sostenibile",
  交割:"Consegna",
  永续合约:"Contratto perpetuo",
  交割合约:"Contratto di consegna",
  全仓:"Magazzino pieno",
  开多:"Aperto a lungo",
  开空:"Aperto breve",
  价格:"prezzo",
  开仓金额:"Importo di apertura",
  可用金额:"Importo disponibile",
  合约金额:"Ammontare del contratto",
  保证金:"margine",
  手续费:"commissione di gestione",
  看涨:"rialzista",
  看跌:"Ribassista",
  交割时间:"tempi di consegna",
  数量:"quantità",
  持有仓位:"Mantieni una posizione",
  当前委托:"Ordine attuale",
  历史订单:"Ordini storici",
  暂无数据:"Nessun dato",
  购买价:"prezzo d'acquisto",
  市价: "prezzo di mercato",
    限价: "limite di prezzo",
  现价:"Prezzo attuale",
  金额:"Quantità",
  盈亏:"Profitti e perdite",
  操作:"operare",
  平仓:"Posizione chiusa",
  撤单:"Annulla Ordine",
  方向:"direzione",
  剩余时间:"tempo rimasto",
  交割时间:"tempi di consegna",
  详情:"Dettagli",
  名称:"nome",
  最新价格:"ultimo prezzo",
  h24涨跌:"24 ore su 24, alti e bassi",
  h24涨跌幅:"Incremento e decremento nelle 24 ore",
  请输入开仓金额:"Inserisci l'importo di apertura",
  请输入开仓价格:"Inserisci il prezzo di apertura",
  确定执行撤单操作:"Sei sicuro di voler annullare l'ordine?",
  确定执行平仓操作:"Sei sicuro di eseguire l'operazione di chiusura della posizione?",
  交割合约历史:"Storico dei contratti di consegna",
  历史仓位:"Posizioni storiche",
  到期时间:"Data di scadenza",
  闪兑:"Scambio lampo",
  从:"da",
  最大:"massimo",
  可用数量:"quantità disponibile",
  至:"A",
  复制成功:"Copiato con successo",
  基金理财:"Gestione finanziaria del fondo",
  托管金额:"Importo del deposito in garanzia",
  总收益:"Entrate totali",
  当日收益:"Reddito del giorno",
  托管订单:"Ordine di deposito a garanzia",
  规则:"regola",
  日收益:"Reddito giornaliero",
  限额:"limite",
  周期:"ciclo",
  天:"cielo",
  立即买入:"Acquista ora",
  购买:"Acquistare",
  购买日:"Data di acquisto",
  起息日:"data di valuta",
  派息时间:"Tempo di pagamento dei dividendi",
  每日:"quotidiano",
  计息结束日:"Data di fine maturazione degli interessi",
  提前赎回:"rimborso anticipato",
  预计收益:"Entrate stimate",
  今日日收益:"Oggi (reddito giornaliero)",
  最少可投:"Investimento minimo",
  最大可投:"Massimo investimento",
  请输入买入金额:"Inserisci l'importo dell'acquisto",
  可用金额:"Importo disponibile",
  请输入买入金额:"Inserisci l'importo dell'acquisto",
  质押金额:"Importo del pegno",
  累计收益:"Reddito cumulativo",
  开始时间:"Tempo di partenza",
  结束时间:"Tempo scaduto",
  理财规则:"regole finanziarie",
  理财规则1:"La gestione finanziaria viene effettuata affidando USD alla piattaforma e il team di professionisti della piattaforma effettua l'arbitraggio finanziario. I partecipanti possono ottenere una quota del reddito della gestione finanziaria della piattaforma durante il periodo di custodia del fondo.",
  收益计算:"Calcolo dei ricavi",
  理财规则2:"Un membro deposita 10.000U sulla piattaforma e sceglie un prodotto finanziario con un ciclo di 5 giorni e un reddito giornaliero dello 0,3%~0,5%. Il reddito giornaliero è il seguente:",
  最低:"più basso",
  最高:"Più alto",
  理财规则3:"Entrambi: puoi ottenerlo dopo 5 giorni",
  理财规则4:"Il reddito distribuito viene distribuito quotidianamente. È possibile accedervi, ritirarlo in qualsiasi momento e depositarlo nel capitale. Dopo la scadenza, verrà automaticamente restituito al tuo conto.",
  关于违约金:"A proposito di liquidazione dei danni",
  理财规则5:"Se si desidera trasferire il capitale non scaduto, si dovrà sostenere una liquidazione dei danni.",
  理财规则6:"Danni liquidati = rapporto di liquidazione x giorni rimanenti x importo dell'investimento.",
  理财规则7:"Esempio: il rapporto di liquidazione dei danni di questo prodotto è",
  剩余:"Residuo",
  天到期投资:"Scade tra giorni e l'importo dell'investimento è",
  则:"Ma",
  违约金:"danni liquidati",
  实际退还本金为:"Il capitale effettivo restituito è",
  现货账户:"conto spot",
  总资产:"Totale attivo",
  充币:"Deposita monete",
  提币:"Ritirare le monete",
  闪兑:"Scambio lampo",
  投资组合:"portafoglio",
  冻结数量:"quantità congelata",
  帮助中心:"Centro assistenza",
  自选:"Opzionale",
  行情:"Citazioni",
  资金:"fondi",
  资讯:"Informazione",
  我的:"mio",
  交易对:"coppia commerciale",
  最新价:"Ultimo prezzo",
  成交量:"Volume",
  标记价格:"segnare il prezzo",
  h24最高价:"Prezzo più alto 24 ore",
  h24最低价:"Prezzo più basso 24 ore su 24",
  h24成交量:"Volume degli scambi nelle 24 ore",
  h24交易额:"Volume delle transazioni 24 ore su 24",
  分时:"condivisione del tempo",
  分1:"1 punto",
  分5:"5 punti",
  分15:"15 punti",
  分30:"30 punti",
  小时1:"1 ora",
  天1:"1 giorno",
  周1:"1 settimana",
  月1:"Gennaio",
  委托订单:"Ordine",
  最新交易:"Ultime transazioni",
  买入:"Acquistare",
  卖出:"vendere",
  时间:"tempo",
  方向:"direzione",
  取消自选成功:"Annulla la selezione con successo",
  添加成功:"Aggiunto con successo",
  登录:"Login",
  账户:"Account",
  邮箱:"Posta",
  手机号:"Numero di telefono",
  请输入账户:"Inserisci l'account",
  请输入邮箱:"per favore inserisci la tua email",
  请输入手机号:"Inserisci il numero di telefono",
  密码:"parola d'ordine",
  请输入密码:"Per favore, inserisci la password",
  忘记密码:"dimenticare la password?",
  还没有账号:"Nessun account ancora",
  去注册:"Vai alla registrazione",
  请输入登录账号:"Inserisci il tuo account di accesso",
  请输入登录密码:"per favore inserisci LA TUA password",
  登录失败:"Accesso non riuscito",
  历史记录:"registro della storia",
  充值:"Riempire",
  提现:"ritirare",
  未审核:"Non recensito",
  成功:"successo",
  失败:"fallire",
  快捷入口:"Ingresso rapido",
  资金密码:"Password del fondo",
  登录密码:"password per il login",
  账变记录:"Record di modifica dell'account",
  邀请推广:"Invito alla promozione",
  通用:"universale",
  语言:"lingua",
  在线客服:"Servizio Online",
  身份认证:"Autenticazione",
  高级认证:"Certificazione avanzata",
  更多:"Di più",
  帮助中心:"Centro assistenza",
  关于我们:"chi siamo",
  退出:"esentato",
  已提交身份认证:"Hai inviato le informazioni sulla tua identità e sono in fase di revisione",
  您已完成身份认证:"Hai completato la verifica dell'identità",
  您已完成高级认证:"Hai completato la certificazione avanzata",
  确定退出登录:"Sei sicuro di voler uscire?",
  资讯:"Informazione",
  公告:"annuncio",
  状态:"stato",
  已成交:"Affare fatto",
  委托金额:"Importo della commissione",
  剩余金额:"bilancia",
  订单类型:"Tipo di ordine",
  市价委托:"ordine di mercato",
  限价委托:"ordine limite",
  订单号:"numero d'ordine",
  委托时间:"Tempo della Commissione",
  U本位合约历史:"Storia del contratto basato su U",
  成交数量:"Il numero di transazioni",
  实现盈亏:"Realizza profitti e perdite",
  推广记录:"Registro della promozione",
  我的总推广:"La mia promozione generale",
  总充值:"Ricarica totale",
  一代人数:"Numero di generazioni",
  二代人数:"Numero di seconda generazione",
  三代人数:"Numero di tre generazioni",
  立即推广:"Promuovi adesso",
  我的推广:"la mia promozione",
  用户名:"nome utente",
  行情:"Citazioni",
  加密货币:"criptovaluta",
  外汇:"Forex",
  股票:"azione",
  现货交易:"Commercio a pronti",
  期货:"Futuro",
  热门:"Popolare",
  涨幅榜:"Elenco dei vincitori",
  跌幅榜:"Elenco dei perdenti",
  快速充币:"Deposito rapido",
  保存二维码:"Salva il codice QR",
  复制地址:"Copia indirizzo",
  转出地址:"Indirizzo di trasferimento (facoltativo)",
  请输入转出地址:"Inserisci l'indirizzo di trasferimento",
  粘贴:"Impasto",
  充币数量:"Importo del deposito",
  请输入充币数量:"Inserisci l'importo del deposito",
  区块链网络:"Rete blockchain",
  付款凭证:"Voucher di pagamento (carica screenshot dei dettagli di pagamento)",
  请输入充值数量:"Inserisci l'importo della ricarica",
  充值通道:"Canale di ricarica",
  请选择充值币种:"Seleziona la valuta di ricarica",
  官方充值通道:"Canale ufficiale di ricarica",
  设置密码:"impostare la password",
  确认密码:"Conferma password",
  验证码:"Codice di verifica",
  请输入验证码:"inserisci il codice di verifica",
  获取验证码:"ottenere il codice di verifica",
  重新发送:"Invia nuovamente",
  邀请码:"Codice invito",
  请输入邀请码:"Inserisci il codice di invito",
  我已阅读并同意:"Ho letto e sono d'accordo",
  服务条款:"Termini di servizio",
  注册:"Registrati",
  已有账号:"Hai già un account",
  去登录:"Vai al login",
  请再次输入密码:"Inserisci nuovamente la password",
  请同意服务条款:"Si prega di accettare i termini di servizio",
  注册失败:"registrazione fallita",
  欢迎来到:"Benvenuto a",
  全球最大的区块链资产平台:"La più grande piattaforma di asset blockchain al mondo",
  分享二维码:"Condividi il codice QR",
  链接分享:"Condivisione dei collegamenti",
  复制:"copia",
  您的邀请码:"il tuo codice di invito",
  到数字币地址:"All'indirizzo della valuta digitale",
  选择币种:"Seleziona valuta",
  区块链网络:"Rete blockchain",
  提币说明:"Istruzioni per il ritiro",
  提现费用:"Commissioni di prelievo",
  可到账数量:"Quantità disponibile",
  可用:"Disponibile",
  请输入支付密码:"Inserisci la password di pagamento",
  请输入提币数量:"Inserisci l'importo del prelievo",
  全部:"Tutto",
  支付密码:"Password di pagamento",
  地址:"indirizzo",
  委托价:"Prezzo dell'ordine",
  成交时间:"Orario della transazione",
  成交金额:"Turnover",
  委托中:"Su commissione",
  持仓中:"In posizione",
  平仓中:"Chiusura della posizione",
  已平仓:"Posizione chiusa",
  开仓倍数:"Apertura multipla",
  委托价格:"Prezzo della commissione",
  收盘价:"Prezzo di chiusura",
  收益率:"tasso di rendimento",
  平仓时间:"Orario di chiusura",
  请输入转换数量:"Inserisci la quantità di conversione",
  请上传付款凭证:"Si prega di caricare il voucher di pagamento",
  开盘价:"prezzo di apertura",
  开市中:"Aprire",
  已休市:"Il mercato è stato chiuso",
  美股:"Azioni statunitensi",
  平仓价:"Prezzo di chiusura",
  到期结算完成:"Completata la liquidazione delle scadenze",
  印度股票:"azioni indiane",
  马来股票:"Azioni malesi",
  结算中:"Stabilirsi",
  越南股票:"azioni vietnamite",
  设置资金密码:"Imposta la password del fondo",
  请输入资金密码:"Inserisci la password del fondo",
  取消:"Annulla",
  确定:"Sicuro",
  止损价:"Prezzo di stop loss",
  请输入止损价格:"Inserisci il prezzo dello stop loss",
  请输入止盈价格:"Inserisci il prezzo take profit",
  止盈价:"Prendi il prezzo di profitto",
  设置止盈止损:"Imposta il take profit e lo stop loss",
  请输入关键词:"Inserisci una parola chiave",
  搜索结果:"risultati di ricerca",
  添加收款方式:"Aggiungi metodo di pagamento",
  高级认证:"Certificazione avanzata",
  历史委托:"commissione storica",
  选择区域码:"Seleziona il prefisso",
  请上传身份证图片:"Per favore carica una foto della tua carta d'identità",
  请上传护照照片:"Si prega di caricare una fototessera",
  请输入提币地址:"Inserisci l'indirizzo di ritiro",
  设置语言:"impostazione della lingua",
  最低金额: "Quantità minima",
  购买金额: "prezzo d'acquisto",
  请输入要搜索的国家名称: "Inserisci il nome del paese che desideri cercare",
  确定执行该操作: "Conferma di farlo?",
  历史搜索: "Ricerche storiche",
  现货持仓: "Posizione spot",
  永续持仓: "Posizione perpetua",
  到期结算中: "Stabilizzazione alla scadenza",
  火花图: "diagramma della scintilla",
  计价单位: "unità di vendita",
  您拒绝了链接: "Hai rifiutato il collegamento",
  连接钱包成功: "Connessione al portafoglio riuscita",
  已断开钱包: "Portafoglio disconnesso",
  钱包切换成功: "Cambio di portafoglio riuscito",
  请先安装钱包插件: "Installa prima il plug-in del portafoglio",
  连接钱包: "Collega il portafoglio",
  交易: "commercio",
  确认报价: "Conferma preventivo",
  您将获得: "otterrete",
  兑换自: "Riscatta da",
  汇率: "tasso di cambio",
  返回: "ritorno",
  兑换: "scambio",
  消息: "informazione",
  身份证反面照片: "Foto del retro della carta d'identità",
  身份证正面照片: "Foto frontale della carta d'identità",
  手持身份证照片: "Foto di una carta d'identità in mano",
  划转: "trasferimento",
  请输入划转数量: "Inserisci l'importo del bonifico(USD)",
  邀请链接: "Collegamento dell'invito",
  资料总览: "Panoramica dei dati",
  推广规则: "Regole della promozione",
  总邀请人数: "Numero totale di invitati",
  总佣金: "commissione totale",
  安全绑定: "rilegatura sicura",
  规则1: "1.Questo indirizzo accetta solo {type}. Non trasferire risorse non {type} a questo indirizzo, altrimenti le risorse non verranno recuperate.",
    规则2: "2.Dopo aver effettuato la ricarica all'indirizzo sopra indicato, devi attendere la conferma da parte del nodo di rete. Una volta confermata dal nodo di rete, gli asset arriveranno automaticamente sul tuo conto. Ti notificheremo lo stato di arrivo sotto forma di annuncio sul sito.",
    规则3: "3.Il tuo indirizzo di ricarica non cambierà frequentemente e potrai ricaricare ripetutamente; se ci sarà qualche cambiamento, ti avviseremo tramite un annuncio sul sito",

    安全中心: "Centro di sicurezza",
    绑定手机号: "Associa il numero di cellulare",
    认证中心: "Centro di certificazione",
    身份认证: "Autenticazione",
    认证要求: "Requisiti di certificazione",
    政府发行的证件: "Documenti rilasciati dal governo",
    功能与限制: "Caratteristiche e limitazioni",
    无限额: "Senza limiti",
    预计审核时间: "Tempo stimato per la revisione: 60 minuti",
    开始认证: "Inizia la certificazione",
    充币规则: "Regole di deposito",
    套期保值: "Copertura, copertura del rischio",
    登陆后继续: "Accedi per continuare",
     请选择充值方式:"Seleziona il metodo di ricarica",
    请选择取款方式: "Seleziona il metodo di prelievo",
    客服充值: "Ricarica servizio clienti",
    数字货币: "Valuta digitale",
    银行取款: "Prelievo bancario",
    请输入金额: "Inserisci l'importo",
    银行名称: "Nome della banca",
    银行卡号: "Numero carta bancaria",
    请输入: "Per favore inserisci",
    请选择: "Per favore seleziona",
    类型: "Tipo",
    可用金额: "Importo disponibile",
    提款: "Prelievo"
  }
  
  
  


// WEBPACK FOOTER //
// ./src/lang/italy.js